module.exports = __webpack_public_path__ + "static/media/more_vert.bca0379f.svg";